async function stCustomAddToCart(productId) {
    const productForm = new FormData();
            productForm.append("sections", ["mini-cart"]);
            productForm.append("form_type", "product");
            productForm.append("quantity", "1");
            productForm.append("id", productId);
            productForm.append("utf8", "✓");
            const response = await fetch(
                `${window.themeVariables.routes.cartAddUrl}.js`, {
                    body: productForm,
                    method: "POST",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                }
            );
            const responseJson = await response.json();
            if (response.ok) {
                this.dispatchEvent(
                    new CustomEvent("variant:added", {
                        bubbles: true,
                        detail: {
                            variant: responseJson.hasOwnProperty("items") ?
                                responseJson["items"][0] : responseJson,
                        },
                    })
                );
                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
                    async (response2) => {
                        const cartContent = await response2.json();
                        document.documentElement.dispatchEvent(
                            new CustomEvent("cart:updated", {
                                bubbles: true,
                                detail: {
                                    cart: cartContent,
                                },
                            })
                        );
                        cartContent["sections"] = responseJson["sections"];
                        document.documentElement.dispatchEvent(
                            new CustomEvent("cart:refresh", {
                                bubbles: true,
                                detail: {
                                    cart: cartContent,
                                    openMiniCart: window.themeVariables.settings.cartType === "drawer",
                                },
                            })
                        );
                    }
                );
            } 
            //Code to handle error of ATC i.e. to show the error notification 
            else {
                console.log("Desc is: ", responseJson["description"]);
                let closeButtonHtml = "";
                closeButtonHtml = `
                <button class="cart-notification__close tap-area hidden-phone" data-action="close">
                  <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
                  <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
                    <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
                  </svg>
                </button>
              `;
                let cartNotification = document.querySelector('cart-notification')
                cartNotification.classList.add("cart-notification--error");
                cartNotification.innerHTML = `<div class="cart-notification__overflow">
                  <div class="container">
                    <div class="cart-notification__wrapper">
                      <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                        <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                        <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
                      </svg>

                      <div class="cart-notification__text-wrapper">
                        <span class="cart-notification__heading heading">${responseJson["description"]}</span>
                      </div>

                      ${closeButtonHtml}
                    </div>
                  </div>
                </div>
              `;
                document.querySelector('cart-notification').removeAttribute('hidden');
                setTimeout(() => {
                    document.querySelector('cart-notification').setAttribute('hidden', '');
                }, 3000);
            }
};